// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__enk3F"};